/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

export function getSignInLink (params?: Record<string, unknown>) {
  return `/sign-in${stringify(params, { addQueryPrefix: true })}`
}

export function getSignOutLink () {
  return '/sign-out'
}
